/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProfilePatchAction {
    ADD = 'Add',
    REMOVE = 'Remove',
    UPDATE = 'Update',
}
